import DisapperaingPopup from './DisapperaingPopup';
export default DisapperaingPopup;
